// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const oilPress = defineModel({
  id: "oil-press",
  batchId: "future",
  name: "Oil press",
  tags: ["building","oil","press","low-poly","age-of-mcp","future"],
  summary: "Presses olives, seeds or nuts into oil — food, lamps, soap and lubricant.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.45, 0.45, 1.1), color: "#8d8678", position: [0, 0.365, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [-0.725, 0.365, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [0.725, 0.365, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [-0.725, 0.365, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [0.725, 0.365, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.775, 0.45, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.775, 0.45, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.775, 0.45, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.775, 0.45, 0.775] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.45, 0.9, 1.1), color: "#8d8678", position: [0, 0.59, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [-0.725, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [0.725, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [-0.725, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [0.725, 0.59, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.775, 0.7, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.775, 0.7, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.775, 0.7, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.775, 0.7, 0.775] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.45, 0.9, 1.1), color: "#8d8678", position: [0, 0.59, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [-0.725, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [0.725, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [-0.725, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#6c665a", position: [0.725, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(1.67, 0.07, 0.800608), color: "#7a4a36", position: [0, 1.25, 0.305], rotation: [0.602983, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.67, 0.07, 0.800608), color: "#7a4a36", position: [0, 1.25, -0.305], rotation: [-0.602983, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.69, 0.085, 0.085), color: "#5a3526", position: [0, 1.46, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.52, 0.05), color: "#5a4530", position: [0, 0.4, 0.56] },
      { geometry: new THREE.CylinderGeometry(0.24, 0.27, 0.16, 10), color: "#6c665a", position: [0.66, 0.22, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.6, 8), color: "#3c4146", position: [0.66, 0.6, 0.5] },
      { geometry: new THREE.BoxGeometry(0.5, 0.07, 0.07), color: "#5f3f20", position: [0.66, 0.86, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.0715, 0.052, 0.1088, 8), color: "#a6743a", position: [-0.66, 0.1944, 0.52] },
      { geometry: new THREE.SphereGeometry(0.13, 8, 6), color: "#a6743a", position: [-0.66, 0.31, 0.52], scale: [1, 1.05, 1] },
      { geometry: new THREE.CylinderGeometry(0.0364, 0.0442, 0.0748, 8), color: "#a6743a", position: [-0.66, 0.4324, 0.52] },
      { geometry: new THREE.CylinderGeometry(0.066, 0.048, 0.096, 8), color: "#9a6a34", position: [-0.5, 0.188, 0.62] },
      { geometry: new THREE.SphereGeometry(0.12, 8, 6), color: "#9a6a34", position: [-0.5, 0.29, 0.62], scale: [1, 1.05, 1] },
      { geometry: new THREE.CylinderGeometry(0.0336, 0.0408, 0.066, 8), color: "#9a6a34", position: [-0.5, 0.398, 0.62] },
    ] },
  ],
  animations: [],
});
